import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form, Button } from "reactstrap";

import { withRouter, Link, useHistory, useLocation } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import Logo from "../../assets/images/logo-large.png";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';


const ChangePasswordPage = props => {
  //meta title
  document.title= 'Change Password';
	const location = useLocation();
  const history = useHistory();
  const { getRequestWOAccessToken, postRequestWOAccessToken } = useRequestsWOAccessToken();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email_otp: '',
      password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object({
      email_otp: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Email OTP is required')
        .min(6, 'Email OTP should be 6 digits!')
        .max(6, 'Email OTP should be 6 digits!'),
      password: Yup.string()
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/\d/, 'Password must contain at least one numeric character')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .max(20, 'Password must be at most 20 characters'),
      confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Both passwords need to be the same!')
        .required('Confirm Password is required')
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          a_id: AID,
          email: Email,
          email_otp: values.email_otp,
          password: values.password,
          confirm_password: values.confirm_password,
        });
        const res = await postRequestWOAccessToken('change-password', jsonpar);
        if (res && res.code === 200) {
          history.push('/login', { code: 200, status: 'success', message: res.message });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Submit';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const resendOTP = async () => {
    const jsonpar = JSON.stringify({
      a_id: AID
    });
    const res = await postRequestWOAccessToken('send-otp', jsonpar);
    if (res && res.code === 200) {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [AID, setAID] = React.useState(0);
  const [Email, setEmail] = React.useState('');
  React.useEffect(() => {
    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAID(location.state.id);
      setEmail(location.state.email);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="account-pages bg-green">
        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody>
                  
                  <Link to="/login" className="logo center-logo">
                    <span className="text-center">
                      <img src={Logo} alt="" />
                    </span>
                  </Link>
                  <h3 className="text-center mt-3 mb-3">Change your password ?</h3>

                  <div className="p-2">
                    <Form>
                      <div className="mb-3">
                        <Label className="form-label">{'Email OTP'} :</Label>
                        <Input
                          name="email_otp"
                          type="text" 
                          placeholder={'Enter OTP'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.email_otp || ""}
                          invalid={
                            validation1.touched.email_otp && validation1.errors.email_otp ? true : false
                          }
                        />
                        {validation1.touched.email_otp && validation1.errors.email_otp ? (
                          <FormFeedback type="invalid">{validation1.errors.email_otp}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">{'Password'} :</Label>
                        <Input
                          name="password"
                          type="password" 
                          placeholder={'Enter password'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.password || ""}
                          invalid={
                            validation1.touched.password && validation1.errors.password ? true : false
                          }
                        />
                        {validation1.touched.password && validation1.errors.password ? (
                          <FormFeedback type="invalid">{validation1.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">{'Confirm password'} :</Label>
                        <Input
                          name="confirm_password"
                          type="password" 
                          placeholder={'Enter confirm password'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.confirm_password || ""}
                          invalid={
                            validation1.touched.confirm_password && validation1.errors.confirm_password ? true : false
                          }
                        />
                        {validation1.touched.confirm_password && validation1.errors.confirm_password ? (
                          <FormFeedback type="invalid">{validation1.errors.confirm_password}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mt-3 d-grid">
                        <button 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                            className="btn btn-primary btn-block"> {'Submit'} </button>
                      </div>
                    </Form>
                    <div className="form-horizontal">
                      <div className="mt-4 text-center">
                        <p className="mb-0"><Link to="#" className="text-green text-underline" onClick={(e) => resendOTP()}> {'Click here to resend.'} </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="footer-text-color">
                  {'Go back to'}{" "}
                  <Link to="login" className="font-weight-medium text-underline">
                    {'Login'}
                  </Link>{" "}
                </p>
                <p className="footer-text-color">
                  © {new Date().getFullYear()} Tokenizedgreen.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ChangePasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ChangePasswordPage);
